import { createContext, useContext } from 'react';
import type { Json } from '../lib/types.ts';

// API prefix the inner components should hit when they save submissions /
// upload files. Companies use /api/me, drivers use /api/driver/me. We pass
// both the prefix and the relevant React Query keys through context so the
// deeply-nested QuestionCard children don't each need an explicit prop.
//
// setLocalAnswer / clearLocalAnswer let a QuestionCard report the answer the
// user just entered up to the wizard, so the step gate reflects it immediately
// instead of only after the save round-trips back from the server.
export type WizardContextValue = {
  apiPrefix: string;
  meQueryKey: readonly unknown[];
  submissionsQueryKey: readonly unknown[];
  setLocalAnswer: (questionId: string, answer: Json | null, comment: string | null) => void;
  clearLocalAnswer: (questionId: string) => void;
};
export const WizardContext = createContext<WizardContextValue>({
  apiPrefix: '/api/me',
  meQueryKey: ['me'],
  submissionsQueryKey: ['me', 'submissions'],
  setLocalAnswer: () => {},
  clearLocalAnswer: () => {},
});

export function useWizardCtx(): WizardContextValue {
  return useContext(WizardContext);
}
